import React from 'react';
import 'whatwg-fetch';
import PanelBossNote from './PanelBossNote';

const AppHome = () => {
  return (
    <div id='appView' className='div-entity'>
      <PanelBossNote />
    </div>
  );
};

export default AppHome;
